import { render } from "./Boosters.vue?vue&type=template&id=0721a0c4"
import script from "./Boosters.vue?vue&type=script&lang=js"
export * from "./Boosters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__